'use client';

import { Button, Typography, useTheme } from '@mui/material';
import Link from 'next/link';
import { useTranslation } from 'react-i18next';

export const KnowMoreButton = () => {
	const [trans] = useTranslation();
	const theme = useTheme();

	return (
		<Link href={'https://www.fundacion-alala.org/'}>
			<Button
				variant={'outlined'}
				sx={{
					'width': '100%',
					'textTransform': 'none',
					'backgroundColor': '#ed77bf',
					'borderColor': '#B13D85',
					'&:hover': {
						backgroundColor: '#c8539e',
					},
					[theme.breakpoints.up('sm')]: {
						width: '14rem',
					},
				}}
			>
				<Typography
					sx={{
						color: 'white',
						fontWeight: 900,
						fontSize: '16px',
					}}
				>
					{trans('knowMore')}
				</Typography>
			</Button>
		</Link>
	);
};
